jQuery(function($) {
  $('.modal').on('show.bs.modal', function() {
    $('#page, footer').addClass('blur')
  })

  $('.modal').on('hide.bs.modal', function() {
    $('#page, footer').removeClass('blur')
  })
})
